import { render, staticRenderFns } from "./SysUserPage.vue?vue&type=template&id=10bfdc70"
import script from "./SysUserPage.vue?vue&type=script&lang=js"
export * from "./SysUserPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports